import { BoundForEventType } from '@/constants'
import type { GridCoords } from '@/core/Board/types'
import type { Coords } from '@/core/Game/types'

declare global {
  interface WindowEventMap {
    [BoundForEventType.BoardSelectionEnd]: BoundForEvent<[start: GridCoords, end: GridCoords] | undefined>
    [BoundForEventType.GamePendingChange]: BoundForEvent<[start: Coords, end: Coords][]>
  }
}

type BoundForEventName = Extract<BoundForEventType, keyof WindowEventMap>

class BoundForEvent<P> extends Event {
  readonly payload: P

  constructor(type: BoundForEventType, payload: P) {
    super(type)

    this.payload = payload
  }
}

const makeEvent = <T extends BoundForEventName>(type: T) => ({
  dispatch: (payload: WindowEventMap[T]['payload']) => window.dispatchEvent(new BoundForEvent(type, payload)),
  subscribe: (callback: (event: WindowEventMap[T]) => void): (() => void) => {
    window.addEventListener(type, callback)

    return () => window.removeEventListener(type, callback)
  },
})

export const eventBus = {
  [BoundForEventType.BoardSelectionEnd]: makeEvent(BoundForEventType.BoardSelectionEnd),
  [BoundForEventType.GamePendingChange]: makeEvent(BoundForEventType.GamePendingChange),
}
